module.exports = __webpack_public_path__ + "static/assets/72a0b1d0fb3b27acd5148fa085b00e19.jpg";